/**
 * Распознавание сбоя загрузки lazy-чанка (типично после деплоя: старый
 * index.html ссылается на удалённые /assets/*-<hash>.js) и защита от
 * бесконечной перезагрузки.
 */

const CHUNK_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i, // Chrome
  /error loading dynamically imported module/i, // Firefox
  /Importing a module script failed/i, // Safari
  /Loading chunk [\w-]+ failed/i, // webpack-совместимые сообщения
  /Unable to preload CSS/i, // vite: preload css
]

export function isChunkLoadError(err: unknown): boolean {
  if (!err) return false
  const name = (err as { name?: unknown }).name
  if (name === 'ChunkLoadError') return true
  const message = err instanceof Error ? err.message : String(err)
  return CHUNK_ERROR_PATTERNS.some((re) => re.test(message))
}

export const CHUNK_RELOAD_KEY = 'edpad_chunk_reload_at'
const RELOAD_COOLDOWN_MS = 30_000

type StorageLike = Pick<Storage, 'getItem' | 'setItem'>

/**
 * true — можно один раз автоматически перезагрузить страницу. Повторная
 * автоперезагрузка не чаще раза в 30 с: если чанк недоступен и после
 * перезагрузки, показываем экран ошибки вместо цикла.
 */
export function shouldAutoReloadForChunkError(storage: StorageLike | null, now: number = Date.now()): boolean {
  if (!storage) return false
  try {
    const last = Number(storage.getItem(CHUNK_RELOAD_KEY) ?? 0)
    if (Number.isFinite(last) && now - last < RELOAD_COOLDOWN_MS) return false
    storage.setItem(CHUNK_RELOAD_KEY, String(now))
    return true
  } catch {
    return false
  }
}
